import React from 'react';
import { DEPLOYMENT_PANEL_DATA_TYPE } from '@atlassian/jira-development-details/src/common/model/constants';
import DevPanelDetailsDialog from '@atlassian/jira-development-details/src/main';
import { createAri } from '@atlassian/jira-platform-ari';
import { useProjectContext } from '@atlassian/jira-providers-project-context';
import type { IssueId } from '@atlassian/jira-shared-types';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller';
import { useIssue } from '../../../../../../services/core-data/main';

type Props = {
	issueId: IssueId;
	onClose: () => void;
};

const DeploymentsDevPanel = ({ issueId, onClose }: Props) => {
	const issue = useIssue(issueId);

	const projectContext = useProjectContext();
	const tenantContext = useTenantContext();
	const projectAri = createAri({
		resourceOwner: 'jira',
		resourceType: 'project',
		cloudId: tenantContext.cloudId,
		resourceId: projectContext.data?.projectId?.toString() ?? '',
	});

	return (
		<DevPanelDetailsDialog
			issueId={issueId}
			issueKey={issue?.key ?? ''}
			baseUrl={tenantContext.baseUrl}
			locale={tenantContext.locale}
			selectedTab={DEPLOYMENT_PANEL_DATA_TYPE}
			showRemoteLinks={false}
			onCloseDialog={onClose}
			projectAri={projectAri || ''}
			accountId={tenantContext.atlassianAccountId || ''}
		/>
	);
};

export default DeploymentsDevPanel;
